import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Listing } from '@/features/listing/types';

interface LocalCartItem {
  id: string;
  listing: Listing;
  variant: Listing['variants'][number];
}

interface CartState {
  items: LocalCartItem[];
}

interface CartActions {
  addItem: (item: LocalCartItem) => void;
  removeItem: (itemId: string) => void;
}

export type CartStore = CartState & CartActions;

export const useLocalCart = create(
  persist<CartStore>(
    (set) => ({
      items: [],
      addItem: (item) =>
        set((state) => ({
          items: [...state.items, item],
        })),
      removeItem: (itemId) =>
        set((state) => ({
          items: state.items.filter((item) => item?.id !== itemId),
        })),
    }),
    {
      name: 'cart',
    },
  ),
);
